import styled from "styled-components";
import IconRising from "assets/images/rising-red.svg";

const TotalVotesContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 0;
  padding: 5px 0 0;

  &::before {
    content: url(${IconRising});
  }

  span.num {
    font-size: 14px;
    font-weight: 500;
    padding: 2px 0 0 5px;
  }
`;

export default TotalVotesContainer;
